import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconBox = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--box")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="m13.335.313 8 4A3 3 0 0 1 23 7v9.53a3 3 0 0 1-1.663 2.684l-8 4a3 3 0 0 1-2.684 0L2.65 19.212A2.998 2.998 0 0 1 1 16.519v-9.52a3 3 0 0 1 1.663-2.684L10.665.313a3 3 0 0 1 2.67 0zM3 7.377v9.149c-.003.38.21.729.547.899L11 21.15v-9.774l-8-4zm18 0-8 4v9.768l7.445-3.722A1 1 0 0 0 21 16.53V7.377zm-9.443-5.274L4.241 5.761l7.76 3.88 7.757-3.88-7.314-3.657a.999.999 0 0 0-.887 0z" id="icon--centivo--box"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#icon--centivo--box"/>
      </g>
  </IconWrapper>
)
